import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import FeatureName from "../../../visComponents/featureName";
import FeatureThumbnail from "../../../visComponents/featureThumbnail";
import {featureInterface} from "../../../../interfaces/featureInterface";
import config from "../canvas/store/sqftConfig";
import {injectIntl} from "react-intl";
import {
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
  setSQFTSystemMessage
} from "../../../../actions/sqftMenuFunctions";
import {updateSQFTCalculations} from "../../../../actions/sqftFunctions";
import edgesCanvas from "../canvas/core/controls/edgesCanvas";
import {getStringFeatureName} from "../../../../misc/helpers";

const SqftNavEdgesFeature = (props) => {
  const {edgeFeature, setSQFTSystemMessage, intl, fabricatorData, selectedEdge, setSelectedEdge,
    setSQFTActiveSubMenuButton} = props;

  const edgeClick = (e, disallowDemo) => {
    setSelectedEdge(edgeFeature.dbFeature.id);
    edgesCanvas.setEgeFeature(edgeFeature);
    edgesCanvas.setHighlighting(disallowDemo);
    edgesCanvas.setCursorImage();
    setSQFTActiveSubMenuButton(edgeFeature.dbFeature.id);

    if (window.innerWidth < 991 && !config.tutorialIsRunning) {
      //todo sqft-react
      //Menu.hideSideBarContent(); // hide sidebar menu
    }
  };

  const handleHelpClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setSQFTSystemMessage({
      isOpened: true,
      title: getStringFeatureName(edgeFeature, intl.messages, intl.locale, fabricatorData),
      text: intl.formatMessage({id: edgeFeature.dbFeature.description})
    });
  };

  return (
    <li className={"lightbox-option-round lightbox-option-round--edge " + ( selectedEdge === edgeFeature.dbFeature.id ? "lightbox-option-selected" : "" )}
        data-id ={edgeFeature.dbFeature.id}
        data-shared-feature-name = { getStringFeatureName(edgeFeature, intl.messages, intl.locale, fabricatorData) }
        onClick={edgeClick}>
      <div className="lightbox-help-icon lightbox-help-icon-circle" onClick={handleHelpClick}/>
      <div className="lightbox-option-round-loader-edge"/>
      <FeatureThumbnail feature={edgeFeature}/>
      <div className="lightbox-description-text lightbox-description-text--edge">
        <FeatureName feature={edgeFeature} maxLength={23}/>
      </div>
    </li>
  )
};

SqftNavEdgesFeature.propTypes = {
  edgeFeature: PropTypes.shape(featureInterface)
};

const mapStateToProps = (store) => ({
  updateCalculations: store.sqftState.updateCalculations,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setSQFTSystemMessage,
  updateSQFTCalculations,
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavEdgesFeature)
);
